<template>
  <div class="warp">
    <TabList :props-obj="propsObj" :wd="wd" :search-click="searchClick" />
  </div>
</template>
<script>
import TabList from '@/views/module/moduleList/interactiveTeaApp/tabList';
export default {
  name: 'Applition',
  components: {
    TabList
  },
  props: {
    propsId: {
      default: String,
      type: String
    },
    wd: {
      default: String,
      type: String
    },
    searchClick: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      propsObj: {
        link: 'searchResultDetail'
      }
    };
  },
  watch: {
    propsId: {
      handler: function(val) {
        this.propsObj.propsId = val;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>
